<template>
  <div class="mini-program-authorize-info">
    <div class="mini-program-authorize-info-container">
      <img
        class="mini-program-authorize-info-container__img"
        src="@/assets/images/no-data.png"
      />
      <div
        v-if="title !== ''"
        class="mini-program-authorize-info-container__text"
      >
        {{ title }}
      </div>
      <div
        v-if="content !== ''"
        class="mini-program-authorize-info-container__tip"
      >
        {{ content }}
      </div>
      <mk-button-biz
        v-if="!hideButton"
        type="primary"
        width="154px"
        height="40px"
        class="mini-program-authorize-info-container__button"
        @click="handleOnEnterExamineClick"
      >
        确认小程序授权状态
      </mk-button-biz>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MiniProgramAuthorizeInfo',
  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    hideButton: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleOnEnterExamineClick () {
      this.$router.push({
        name: '授权管理',
        query: {
          type: 2
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mini-program-authorize-info {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .mini-program-authorize-info-container {
    text-align: center;

    .mini-program-authorize-info-container__img {
      width: 100px;
      height: 74px;
    }

    .mini-program-authorize-info-container__text {
      margin-top: 34px;
      font-size: 14px;
      color: #595959;
    }

    .mini-program-authorize-info-container__tip {
      margin-top: 5px;
      color: #8c8c8c;
      font-size: 12px;
    }

    .mini-program-authorize-info-container__button {
      margin-top: 28px;
    }
  }
}
</style>
